import axios from "axios";
import config from "../Utility/ConfigUtility";
import { paramsInQueryStringFormat } from "../Utility/ServiceUtility";
import { alert } from "../Components/Shared/AlertUtility";
import "../Components/Shared/TokenInterceptor";

const UserEndpoints = {
    getSubscriptions : (siteUrl, includeAssets) => axios.get(`${config.apiUrl}/subscriptions${paramsInQueryStringFormat({ siteUrl, includeAssets })}`),
    getRoles : (includeFeatures) => axios.get(`${config.apiUrl}/roles${paramsInQueryStringFormat({ includeFeatures })}`),
    alert
};

export default UserEndpoints;